/* tslint:disable */
import { Injectable } from '@angular/core';
import { Admin } from '../../models/Admin';
import { Player } from '../../models/Player';
import { SocialAccount } from '../../models/SocialAccount';
import { Game } from '../../models/Game';
import { Prize } from '../../models/Prize';
import { Emoji } from '../../models/Emoji';
import { GameEmoji } from '../../models/GameEmoji';
import { GamePlayer } from '../../models/GamePlayer';
import { GamePlayerEmoji } from '../../models/GamePlayerEmoji';
import { Email } from '../../models/Email';
import { Container } from '../../models/Container';
import { Resource } from '../../models/Resource';
import { GameCategory } from '../../models/GameCategory';
import { PlayerShare } from '../../models/PlayerShare';
import { Content } from '../../models/Content';
import { Inquiry } from '../../models/Inquiry';
import { Language } from '../../models/Language';
import { Translation } from '../../models/Translation';
import { DonationCategory } from '../../models/DonationCategory';
import { Organization } from '../../models/Organization';
import { PlayerPrize } from '../../models/PlayerPrize';
import { Proxy } from '../../models/Proxy';
import { Notification } from '../../models/Notification';
import { PlayerNotification } from '../../models/PlayerNotification';
import { PlayerMeta } from '../../models/PlayerMeta';
import { Survey } from '../../models/Survey';
import { PlayerSurvey } from '../../models/PlayerSurvey';
import { PlayerGameCategory } from '../../models/PlayerGameCategory';
import { Reward } from '../../models/Reward';
import { PlayerReward } from '../../models/PlayerReward';

export interface Models { [name: string]: any }

@Injectable()
export class SDKModels {

  private models: Models = {
    Admin: Admin,
    Player: Player,
    SocialAccount: SocialAccount,
    Game: Game,
    Prize: Prize,
    Emoji: Emoji,
    GameEmoji: GameEmoji,
    GamePlayer: GamePlayer,
    GamePlayerEmoji: GamePlayerEmoji,
    Email: Email,
    Container: Container,
    Resource: Resource,
    GameCategory: GameCategory,
    PlayerShare: PlayerShare,
    Content: Content,
    Inquiry: Inquiry,
    Language: Language,
    Translation: Translation,
    DonationCategory: DonationCategory,
    Organization: Organization,
    PlayerPrize: PlayerPrize,
    Proxy: Proxy,
    Notification: Notification,
    PlayerNotification: PlayerNotification,
    PlayerMeta: PlayerMeta,
    Survey: Survey,
    PlayerSurvey: PlayerSurvey,
    PlayerGameCategory: PlayerGameCategory,
    Reward: Reward,
    PlayerReward: PlayerReward,
    
  };

  public get(modelName: string): any {
    return this.models[modelName];
  }

  public getAll(): Models {
    return this.models;
  }

  public getModelNames(): string[] {
    return Object.keys(this.models);
  }
}
